import { RootState } from '../types'

export const getThemes = (state: RootState) => state.themes.themes

export const getThemeValidationResult = (state: RootState) => state.themes.validationResult

export const isValidating = (state: RootState) => state.themes.isValidating

export const selectedTheme = (state: RootState) => state.themes.selectedTheme
